<ng-container class="task-details" *ngIf="task">
    <form class="ui small static form">
        <h1 class="ui header">{{ 'employees.task-details.taskDetails' | appTranslate }}</h1>

        <!--Name-->
        <div class="field">
            <label>{{ 'employees.task-details.name' | appTranslate }}</label>
            {{ task.name }}
        </div>

        <!--Description-->
        <div class="field">
            <label>{{ 'employees.task-details.description' | appTranslate }}</label>
            <div [innerHtml]="task.description | nl2br | sanitizeHtml"></div>
        </div>

        <!--Due Date-->
        <div class="field">
            <label>{{ 'employees.task-details.dueDate' | appTranslate }}</label>
            {{ task.dueAt }}
        </div>

        <!--Assigned to-->
        <div class="field">
            <label>{{ 'employees.task-details.assignedTo' | appTranslate }}</label>
            {{ task.assignee ? 'Assigned to ' + task.assignee.fullName : 'Unassigned' }}
        </div>

        <!--buttons-->
        <div class="actions">
            <ui-button type="primary" (click)="onDone()">{{ 'employees.task-details.done' | appTranslate }}</ui-button>
        </div>
    </form>
</ng-container>
